import { createSlice } from "@reduxjs/toolkit";

const accountSlice = createSlice({
    name:'account',
    initialState:{
        account:[]
    },
    reducers: {
        addAccount : (state,action) => {
            state.account = [...state.account,action.payload]
        },
        // removeOccupation(){
        //     return state.occupation.filter((item)=> item.id != action.payload);
        // }
    }
});

export const { addAccount } = accountSlice.actions;
export default accountSlice.reducer;